import { useContext } from 'react'

import QueryParamsContext from 'contexts/query-params-context'

export default () => useContext(QueryParamsContext)
